<div class="cardWidget widgetPod">
    <div class="cardWidget-header" [ngClass]="['clickable']" (click)="goToPodValidation(null, null)">
        <span class="cardWidget-header-title" [i18n]="'widgets.pod.title'"></span>
        <button class="cardWidget-header-btn" [ngClass]="refresh ? 'spin' : ''" (click)="$event.stopPropagation(); refreshData()"><i class="fas fa-redo-alt"></i></button>
    </div>

    <div class="cardWidget-content flex-column">
        <div class="calloutWidget _infos">
            <i class="fa fa-info-circle"></i>
            <span [i18n]="'widgets.pod.callout'"></span>
        </div>
        <div class="flex-row flex-space-x">
            <ul class="listPod flex-auto">
                <li class="listPod-item">
                    <span class="listPod-item-title _pending space-between" (click)="goToPodValidation(PodSearchMode.DEFAULT, PodState.PENDING)">
                        <span [i18n]="'widgets.pod.pending'"></span>
                        <strong>{{data.podPending}}</strong>
                    </span>

                    <ul class="listPodSub flex flex-shrink">
                        <li  class="listPodSub-item" (click)="goToPodValidation(PodSearchMode.REJECTED, PodState.PENDING)">
                        <span class="listPodSub-item-title _rejected" [class._noColor]="data.podRejected === 0">
                            <i class="fa fa-warning"></i>
                            <strong>{{data.podRejected}}</strong>
                            <span [i18n]="'widgets.pod.rejected'"></span>
                        </span>
                        </li>

                        <li  class="listPodSub-item" (click)="goToPodValidation(PodSearchMode.DELIVERY_MORE_THAN_ONE_WEEK, PodState.PENDING)">
                        <span class="listPodSub-item-title _outdated" [class._noColor]="data.podOutdatedMoreThanOneWeek === 0">
                            <strong>{{data.podOutdatedMoreThanOneWeek}}</strong>
                            <span [i18n]="'widgets.pod.outdated-more-than-one-week'"></span>
                        </span>
                        </li>

                        <li  class="listPodSub-item" (click)="goToPodValidation(PodSearchMode.DELIVERY_LESS_THAN_ONE_WEEK, PodState.PENDING)">
                        <span class="listPodSub-item-title _outdated" [class._noColor]="data.podOutdatedLessThanOneWeek === 0">
                            <strong>{{data.podOutdatedLessThanOneWeek}}</strong>
                            <span [i18n]="'widgets.pod.outdated-less-than-one-week'"></span>
                        </span>
                        </li>

                        <li  class="listPodSub-item" (click)="goToPodValidation(PodSearchMode.DELIVERY_TODAY, PodState.PENDING)">
                        <span class="listPodSub-item-title _today" [class._noColor]="data.podToday === 0">
                            <strong>{{data.podToday}}</strong>
                            <span [i18n]="'widgets.pod.today'"></span>
                        </span>
                        </li>
                    </ul>
                </li>
            </ul>
            <ul class="listPod flex flex-shrink">
                <li  class="listPod-item" (click)="goToPodValidation(PodSearchMode.DEFAULT, PodState.CHEP_REVIEW)">
                <span class="listPod-item-title _review flex-column">
                    <span [i18n]="'widgets.pod.under-review'"></span>
                    <strong>{{data.podUnderReview}}</strong>
                </span>
                </li>

                <li  class="listPod-item" (click)="goToPodValidation(PodSearchMode.DEFAULT, PodState.VALIDATED)">
                <span class="listPod-item-title _validated flex-column">
                    <span [i18n]="'widgets.pod.validated'"></span>
                    <strong>{{data.podValidated}}</strong>
                </span>
                </li>
            </ul>
        </div>
    </div>
</div>
